import { useEffect, useState } from 'react'

import { openChangeInviteCodeDialogEvent } from '@root/entities/referral'

import { InviteCodeDialog } from './invite-code-dialog'

import type { OpenChangeInviteCodeDialogPayload } from '@root/entities/referral'

export const InviteCodeDialogController = () => {
  const [open, setOpen] = useState<
    OpenChangeInviteCodeDialogPayload | undefined
  >(undefined)

  useEffect(
    () =>
      openChangeInviteCodeDialogEvent.onCall((_, payload) => setOpen(payload)),
    [],
  )

  return (
    <InviteCodeDialog
      open={open !== undefined}
      onOpenChange={() => setOpen(undefined)}
      initialInviteCode={open?.inviteCode}
    />
  )
}
